import type { RangeBarChartConfig } from './types';

// Dashed average / projection line. Matches amcharts4:
//   range.grid.stroke = legend.net, strokeWidth 2, strokeOpacity 0.7, dash "8,4".
// When `disableAvg` is true the amCharts version showed the amount as the line
// label; otherwise the amount is rendered by the React overlay card, so the
// markLine label is suppressed here.
export const buildRangeMarkLine = (rangeValue: number, config: RangeBarChartConfig) => {
  const { lineColor, disableAvg, formatAmount, privacyMask } = config;

  return {
    symbol: ['none', 'none'] as [string, string],
    silent: true,
    lineStyle: {
      color: lineColor,
      type: [8, 4] as number[],
      width: 2,
      opacity: 0.7,
    },
    label: disableAvg
      ? {
          show: true,
          formatter: String(privacyMask(formatAmount(rangeValue, 'USD', '0,0.00'))),
          color: lineColor,
          position: 'end' as const,
          fontSize: 24,
        }
      : { show: false },
    data: [{ yAxis: rangeValue }],
  };
};
